<template>
  <div>
    <b-form-group
        label-for="input-6"
        class="custom-label"
    >
      <label-info
          id="popover-target-exercise-level"
          :label-name="fieldName"
          label-info="The Level that you are now"
      />
      <b-dropdown
          id="dropdown-header"
          :text="fieldName"
          block
          variant="primary"
          split
          split-variant="outline-primary"
          class="m-2"
          menu-class="w-100"
      >
        <b-dropdown-header v-if="false" id="dropdown-header-label">
          Dropdown header
        </b-dropdown-header>
        <template #button-content>
           <span
           v-if="selectedOption"
           >
             {{selectedOption.text}}
           </span>
          <strong v-else>
            Select {{ selectWord }}
          </strong>
        </template>
        <b-dropdown-item-button
            v-for="(anOption, i) in fieldOptions"
            aria-describedby="dropdown-header-label"
            @click="handleItemButtonClick(anOption)"
            :key="`level-${i}`"
        >
          <b-row>
            <b-col>
              {{anOption.text}}
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <small>{{anOption.description}}</small>
            </b-col>
          </b-row>
        </b-dropdown-item-button>
      </b-dropdown>
      <pre v-if="!production" class="mt-3 mb-0">{{ selectedOption }}</pre>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LabelInfo from "@/components/blockResources/_components/labelInfo";
import bendExerciseOptionsJSON from "../../../assets/json/bendExerciseOptions.json";
export default {
  name: "Bend_ExerciseLevel",
  components: {
    LabelInfo
  },
  props: {
    fieldName: {
      type: String,
      default: 'Exercise Level',
      required: true
    },
    fieldKey: {
      type: String,
      default: 'exercise_level',
      required: true
    },
    selectWord: {
      type: String,
      default: 'Level',
      required: true
    }
  },
  computed: {
    ...mapGetters({
    }),
  },
  mounted(){
    this.setFieldOptions();
  },
  methods: {
    setFieldOptions(){
      this.fieldOptions =  this.bendExerciseOptionsJSON && Array.isArray(this.bendExerciseOptionsJSON[this.fieldKey]) ?
          this.bendExerciseOptionsJSON[this.fieldKey] :[];
    },
    handleItemButtonClick(theOption){
      this.selectedOption = theOption;
      this.$emit('item-selected', this.fieldKey, theOption.text);
    }
  },
  data() {
    return {
      production: true,
      bendExerciseOptionsJSON,
      fieldOptions: null,
      selectedOption: ''

    };
  }
};
</script>

<style lang="scss" scoped></style>
